var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, ModelSync } from 'vue-property-decorator';
import { BFormGroup, BFormSelect, BFormSelectOption } from 'bootstrap-vue';
import axios from 'axios';
let MouldingColourSelect = class MouldingColourSelect extends Vue {
    constructor() {
        super(...arguments);
        this.colours = [];
    }
    get colourOptions() {
        return this.colours.map(colour => ({
            value: colour.id,
            text: colour.name
        }));
    }
    mounted() {
        axios.get('/api/materials/moulding/colours')
            .then(({ data }) => this.colours = data);
    }
};
__decorate([
    ModelSync('colourId', 'change', Number)
], MouldingColourSelect.prototype, "selectedColourId", void 0);
MouldingColourSelect = __decorate([
    Component({
        components: {
            BFormGroup, BFormSelect, BFormSelectOption
        }
    })
], MouldingColourSelect);
export default MouldingColourSelect;
